import LandingPage from "views/LandingPage/LandingPage.jsx";
import MapPage from "views/MapPage/MapPage.jsx";
import AdditionalInfoPage from "views/AdditionalInfoPage/AdditionalInfoPage";
import DashProtectedPage from "views/Dashboards/DashProtectedPage";
import DashCountryPage from "views/Dashboards/DashCountryPage";
import DashCountyPage from "views/Dashboards/DashCountyPage";
import DashMunicipalitiesPage from "views/Dashboards/DashMunicipalitiesPage";
import DashBioGeoPage from "views/Dashboards/DashBioGeoPage";
import TermsOfUsePage from "views/TermsOfUsePage/TermsOfUsePage";

var indexRoutes = [
  { path: "/map-page", name: "MapPage", component: MapPage },
  { path: "/dash-country", name: "DashCountryPage", component: DashCountryPage},
  { path: "/dash-county/:id1?/:id2?", name: "dashCountyPage", component: DashCountyPage},
  { path: "/dash-municipality/:id1?/:id2?", name: "DashMunicipalitiesPage", component: DashMunicipalitiesPage},
  { path: "/dash-protectedareas/:id1?/:id2?", name: "DashProtectedPage", component: DashProtectedPage},
  { path: "/dash-biogeoregions/:id1?/:id2?", name: "DashBioGeoPage", component: DashBioGeoPage},
  { path: "/additional-info", name: "AdditonalInfoPage", component: AdditionalInfoPage},
  { path: "/uvjeti-koristenja", name: "TermsOfUsePage", component: TermsOfUsePage},
  { path: "/", name: "LandingPage", component: LandingPage }
];

export default indexRoutes;
